import useInfiniteScroll from './useInfiniteScrollHandler';

const useInfiniteList = ({
  container = null,
  data = [],
  renderItem = () => '',
  Loader = null,
  loadMore = () => ''
}) => {
  const [isFetching, setIsFetching] = useInfiniteScroll(
    // eslint-disable-next-line no-use-before-define
    onScrollEnd,
    container
  );

  function onScrollEnd() {
    if (data && !data.isFetching && isFetching) {
      if (data.next) {
        const loadPromise = loadMore();
        if (!loadPromise) return;
        loadPromise.then(() => {
          setIsFetching(false);
        });
      } else setIsFetching(false);
    } else setIsFetching(false);
  }

  return [
    data?.results?.map?.((dataItem, index) => renderItem(dataItem, index)) || []
  ].concat(data.isFetching && Loader ? <Loader /> : '');
};

export default useInfiniteList;
